<template>
    <div>

        <PageHeader header-id="tb-Widget-header-1">
            {{ $t('widgetAndSettings') }}
            <template #subtitle>
                <div class="d-flex gap-2 flex-column">
                    <div>{{ $t('forEachPageAddedYouHaveOneTipBoxWidget') }}</div>
                    <div class="d-flex gap-1">
                        <div v-html="$t('ifYouWantToUseTipBoxInSocialMediaGoToYourProfil')"></div>
                    </div>
                </div>
            </template>
            <template #bottom>
                <div class="d-flex gap-3">
                    <ButtonIcon
                        icon="file-text"
                        :icon-size="24"
                        href="https://getbuybox.com/ustawienia-i-implementacja-widzetu-tip-box/"
                        target="_blank"
                        variant="link"
                        class="p-0"
                    >
                        {{ $t('seeHowToHighlightTheTipBoxWidgetAndPutItOnTheWebsite') }}
                    </ButtonIcon>
                </div>
            </template>
        </PageHeader>

        <PageLoading v-if="loading && !items.length" />

        <DataTable
            v-else-if="loading || items.length"
            header-id="tb-Widget-header-2"
            :header="$t('pagesList')"
            :error="error"
            :items="items"
            :fields="fields"
            class="mb-0 border-bottom"
            :pagination="false"
            :hover="false"
        >
            <template #head(name)="{label}">
                <span id="tb-Widget-label-1" class="text-link-label-1">{{ label }}</span>
            </template>
            <template #cell(action)="data">
                <ButtonIcon size="sm" :to="getItemUrl(data.item)">{{ $t('editSettings') }}</ButtonIcon>
            </template>
        </DataTable>

        <Card v-else :header="$t('pagesList')">
            <AddFirstSpace />
        </Card>

    </div>
</template>



<script>
    import DataTable from '@/components/common/DataTable.vue';
    import PageLoading from '@/components/common/PageLoading.vue';
    import AddFirstSpace from './parts/AddFirstSpace.vue';

    export default {
        name: 'WidgeterTipboxSettings',
        components: {
            DataTable,
            PageLoading,
            AddFirstSpace,
        },
        data() {
            return {
                requestSpaces: this.$req('space/Spaces'),
            };
        },
        computed: {
            fields() {
                return [
                    { key: 'name', label: this.$t('name') },
                    { key: 'action', label: '', tdClass: 'text-right', thClass: 'text-right' },
                ];
            },
            items() {
                return this.requestSpaces.getData()?.items || [];
            },
            error() {
                return this.requestSpaces.getError();
            },
            loading() {
                return this.requestSpaces.getLoading();
            },
        },
        methods: {
            fetchSpaces() {
                const userId = this.$store.getters['auth/getUser'].id;
                this.requestSpaces.get(userId, { statuses: '1,2' }).catch(() => {});
            },
            getItemUrl(item) {
                return { name: 'WidgeterTipboxSettingsEdit', params: { ...this.$route.params, id: item.id } };
            },
        },
        created() {
            this.fetchSpaces();
        },
    };
</script>
